import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"text-align":"center"} }
const _hoisted_3 = {
  key: 0,
  class: "error ion-padding"
}
const _hoisted_4 = {
  key: 1,
  class: "error ion-padding"
}
const _hoisted_5 = {
  key: 2,
  class: "error ion-padding",
  id: "password-guidelines-hover"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "basic-login-text" }, "Account erstellen", -1)
const _hoisted_7 = {
  style: {"text-align":"center"},
  class: "ion-padding"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  style: {"text-align":"center"},
  class: "ion-padding"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { style: {"margin":"auto","text-align":"center"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", {
  style: {"cursor":"pointer"},
  class: "ion-color-medium"
}, "Datenschutz", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "|", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", { style: {"cursor":"pointer"} }, "AGB", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "|", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", { style: {"cursor":"pointer"} }, "Impressum", -1)
const _hoisted_18 = { style: {"margin":"auto","text-align":"center","padding-bottom":"15px","font-size":"7px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_login_success_animation = _resolveComponent("login-success-animation")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_mobility_logo = _resolveComponent("mobility-logo")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { class: "ion-padding" }, {
        default: _withCtx(() => [
          (!$setup.showSuccessMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("p", _hoisted_2, _toDisplayString($setup.registerTitle), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("form", {
                    onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => ($setup.register && $setup.register(...args)), ["prevent"]))
                  }, [
                    _createVNode(_component_ion_card, { class: "ion-no-padding ion-no-margin" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "stacked" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Name")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              modelValue: $setup.registerData.name,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.registerData.name) = $event)),
                              placeholder: "Name",
                              autocomplete: "name",
                              type: "text",
                              requried: "true",
                              tabindex: "1"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        ($setup.nameError)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($setup.nameError), 1))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "stacked" }, {
                              default: _withCtx(() => [
                                _createTextVNode("E-Mail")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              modelValue: $setup.registerData.email,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.registerData.email) = $event)),
                              placeholder: "E-Mail",
                              type: "email",
                              autocomplete: "email",
                              required: "true",
                              tabindex: "2"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        ($setup.emailError)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($setup.emailError), 1))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "stacked" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Passwort")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              modelValue: $setup.registerData.password,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.registerData.password) = $event)),
                              placeholder: "Passwort",
                              type: "password",
                              required: "true",
                              tabindex: "3"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "stacked" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Passwort bestätigen")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              modelValue: $setup.registerData.passwordConfirm,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.registerData.passwordConfirm) = $event)),
                              placeholder: "Passwort bestätigen",
                              type: "password",
                              required: "true",
                              tabindex: "4"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        ($setup.passwordError)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                              _createTextVNode(_toDisplayString($setup.passwordError) + " ", 1),
                              _createElementVNode("button", {
                                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.handlePasswordHover && $setup.handlePasswordHover(...args)))
                              }, "ℹ️")
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ion_button, {
                          class: "basic-login-btn",
                          expand: "block",
                          type: "submit",
                          style: {"min-height":"65px","margin-bottom":"-5px","margin-top":"20px"}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 32)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", null, [
                    _createTextVNode("Bereits registriert? "),
                    _createVNode(_component_router_link, {
                      to: "/login",
                      class: "link-text-color underline"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Melde dich an ")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.showSuccessMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h1", { innerHTML: $setup.registerSuccessTitle }, null, 8, _hoisted_10),
                  _createVNode(_component_login_success_animation, { style: {"max-height":"30rem","width":"100%"} }),
                  _createElementVNode("p", {
                    innerHTML: $setup.getRegisterSuccessBody()
                  }, null, 8, _hoisted_11),
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString($setup.registerGoBackTo) + " ", 1),
                    _createVNode(_component_router_link, {
                      to: "/login",
                      class: "link-text-color underline"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Login ")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_12, [
            _createElementVNode("span", null, [
              _createVNode(_component_router_link, { to: "/privacy-crudafoch" }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ]),
            _hoisted_14,
            _createElementVNode("span", null, [
              _createVNode(_component_router_link, { to: "/terms" }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              })
            ]),
            _hoisted_16,
            _createElementVNode("span", null, [
              _createVNode(_component_router_link, { to: "/impress" }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("p", _hoisted_18, " Version: " + _toDisplayString($setup.appVersion), 1),
          _createVNode(_component_mobility_logo)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}